const User = class User {
    constructor() {
        this.id = null;
        this.role = '';
        this.fullName = '';
        this.phone = '';
        this.email = '';
        this.city = null;
        this.country = null;
        this.department = null;
        this.state = null;
        this.isActive = true;
        this.avatar = null;
        this.data = {
            position: null,
            information: null
        };
        this.customFields = [];
    }
};

export default User;
